import script from "./BaseMessageField.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMessageField.vue?vue&type=script&setup=true&lang=js"

import "./BaseMessageField.vue?vue&type=style&index=0&id=2eada58c&lang=css"

const __exports__ = script;

export default __exports__